import { render, staticRenderFns } from "./ReportStatStaticCard.vue?vue&type=template&id=8ed93f78&"
import script from "./ReportStatStaticCard.vue?vue&type=script&lang=js&"
export * from "./ReportStatStaticCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportStatStaticCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports